import { NgModule } from '@angular/core';
import { HisTableSharedModule } from './his-table-shared.module';

@NgModule( {
    imports: [HisTableSharedModule],
    exports: [HisTableSharedModule]
} )
export class HisTableCoreModule { }